module.exports = __webpack_public_path__ + "img/jhzg.9cdb5c5b.png";